
import Vue from "vue";
import { mapState } from "vuex";
import { resolveLocalizedResponsiveAsset } from "../utils";

export default Vue.extend({
  methods: {
    resolveAsset(baseKey: string): string {
      return resolveLocalizedResponsiveAsset({
        assetMap: this.oss,
        baseKey,
        isCN: this.isCN,
        isMobile: this.isMobile
      });
    }
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
      isMobile: "isMobile"
    }),
    ...mapState("assets", {
      oss: "oss"
    })
  }
});
